// extracted by mini-css-extract-plugin
export default {"subcategoriesRow":"l_bn","subcategoryColumn":"l_bp","articleLink":"l_bq","articleCoverImage":"l_br","articleTitle":"l_bs"};